import React from "react";
import { Box, Typography } from "@mui/material";

const DifficultyBadge = ({ activity }) => {
  //Estilização e lógica da dificuldade
  const difficulties = {
    1: { color: "#11A823", name: "Dificuldade 1" },
    2: { color: "#F2A024", name: "Dificuldade 2" },
    3: { color: "#E86565", name: "Dificuldade 3" },
  };

  const difficultyLabel = activity.difficulty;

  const difficultyColor = difficulties[difficultyLabel]?.color || "grey";
  const difficultyName = difficulties[difficultyLabel]?.name || "Indefinido";

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        backgroundColor: difficultyColor,
        borderRadius: "31px",
        border: "0.9px solid #ffffff",
        boxShadow: "0px 0px 1.8px 0px rgba(27, 111, 20, 0.14) ",
        width: "107px",
        padding: "3px",
      }}
    >
      <Typography
        data-testid="modalInfoActivities_difficulty_text"
        sx={{
          color: "#FFFCFC",
          fontSize: " 12px",
          fontWeight: " 600",
          textTransform: "uppercase",
          textAlign: "center",
        }}
        // gutterBottom
      >
        {difficultyName}
      </Typography>
    </Box>
  );
};

export default DifficultyBadge;
